import { Button, Tooltip } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import React from 'react';

interface Props {
  disabled: boolean;
  onClick: () => void;
}

export const DeleteCustomerButton = ({ disabled, onClick }: Props) => {
  return (
    <Tooltip
      title={disabled && 'This customer cannot be deleted because there is some data associated with them'}
      placement={'bottom'}
    >
      <Button
        className={`list-button ${!disabled && 'list-button--delete'}`}
        icon={<DeleteOutlined style={{ fontSize: '19px' }} />}
        size='small'
        disabled={disabled}
        onClick={onClick}
      />
    </Tooltip>
  );
};
